import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { usePayoutApi } from '../api';
import { payoutKeys } from '../query-key-factory';
import { StoreItemHistoricalTransactionCountResponse } from './types';

type StoreItemHistoricalTransactionParams = {
  causeId: string;
  storeItemId: string;
};

const useShowHistoricalTransactionCount = ({
  causeId,
  storeItemId,
}: StoreItemHistoricalTransactionParams) => {
  const PayoutApi = usePayoutApi();

  const storeItemQuery = useMemo(() => {
    switch (storeItemId) {
      case 'pos':
      case 'product_fundraisers':
      case 'shop_to_give':
        return `${storeItemId}`;
      default:
        return `store_items/${storeItemId}`;
    }
  }, [storeItemId]);

  const get = async () => {
    const { data } = await PayoutApi.get<StoreItemHistoricalTransactionCountResponse>(
      `/${storeItemQuery}?total=true&cause_id=${causeId}`
    );
    return data;
  };

  const key = causeId ? payoutKeys.id(causeId).storeItems.id(storeItemId).count : [];
  return useQuery({
    queryKey: key,
    queryFn: get,
    enabled: !!storeItemId,
  });
};

export { useShowHistoricalTransactionCount };
